/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_0_AnswerInputs */

const en_gc_search_guides_what_is_gridcraft_sections_8_questions_0_answer = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_0_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The build covered here is alpha software. Small successful examples do not establish compatibility with large models, advanced objects or automation. Use the comparison guide and check the files you actually need.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_8_questions_0_answer = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_0_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不能这样认定。这里介绍的版本仍处于 Alpha 阶段。小示例运行成功，并不能证明它兼容大型模型、高级对象或自动化流程。请结合对比指南，检查实际需要使用的文件。`)
};

/**
* | output |
* | --- |
* | "No. The build covered here is alpha software. Small successful examples do not establish compatibility with large models, advanced objects or automation. Use..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_0_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_8_questions_0_answer = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_0_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_0_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_8_questions_0_answer(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_8_questions_0_answer(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_8_questions_0_answer as "gc.search_guides.what_is_gridcraft.sections.8.questions.0.answer" }